import React, { useEffect } from 'react';

const SectionHeightAdjuster: React.FC = () => {
  // Fonction pour détecter si on est sur mobile
  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           window.innerWidth <= 768;
  };

  const adjustSectionHeights = () => {
    if (isMobile()) {
      return;
    }

    const windowHeight = window.innerHeight;
    const sections = document.querySelectorAll('section');
    const navbar = document.querySelector('nav');
    const navbarHeight = navbar ? navbar.offsetHeight : 0;

    sections.forEach((section, index) => {
      if (section.id === 'footer') return;

      // min-height = viewport, mais la section peut grandir avec le contenu
      section.style.minHeight = `${windowHeight}px`;
      section.style.height = 'auto';
      section.style.overflow = 'visible';

      if (index === 0) {
        section.style.paddingTop = `${navbarHeight}px`;
      }

      // Ancre pour le snap
      if (!section.querySelector(`#${section.id}-anchor`)) {
        const anchor = document.createElement('div');
        anchor.id = `${section.id}-anchor`;
        anchor.style.position = 'absolute';
        anchor.style.top = '0';
        anchor.style.left = '0';
        anchor.style.width = '1px';
        anchor.style.height = '1px';
        anchor.style.pointerEvents = 'none';
        section.style.position = 'relative';
        section.appendChild(anchor);
      }
    });
  };

  useEffect(() => {
    // Désactiver complètement sur mobile
    if (isMobile()) {
      return;
    }

    // Ajuster les hauteurs au chargement
    adjustSectionHeights();
    
    // Ajuster les hauteurs lors du redimensionnement de la fenêtre
    window.addEventListener('resize', adjustSectionHeights);
    
    // Ajuster après un court délai pour s'assurer que le contenu est chargé
    const timeoutId = setTimeout(() => {
      adjustSectionHeights();
    }, 500);
    
    return () => {
      window.removeEventListener('resize', adjustSectionHeights);
      clearTimeout(timeoutId);
    };
  }, []);

  return null; // Ce composant ne rend rien visuellement
};

export default SectionHeightAdjuster; 